import * as api from "../Api";
import {
    searchCustomerByCodeRequestFailed,
    searchCustomerByCodeRequestSuccess,
    searchCustomerByNameRequestFailed,
    searchCustomerByNameRequestSuccess
} from "./CustomerViewActions";


export const searchCustomersByCode = (searchKey) => {
    return (dispatch) => {
        api.searchCustomersByCode(searchKey)
            .then(resp => {
                if (resp.data.success) {
                    dispatch(searchCustomerByCodeRequestSuccess(resp.data.data))
                } else {
                    dispatch(searchCustomerByCodeRequestFailed(resp.data.message))
                }
            }).catch(error => {
            dispatch(searchCustomerByCodeRequestFailed(error.message))
        })
    }
}


export const searchCustomersByName = (searchKey) => {
    return (dispatch) => {
        api.searchCustomersByName(searchKey)
            .then(resp => {
                if (resp.data.success) {
                    dispatch(searchCustomerByNameRequestSuccess(resp.data.data))
                } else {
                    dispatch(searchCustomerByNameRequestFailed(resp.data.message))
                }
            }).catch(error => {
            dispatch(searchCustomerByNameRequestFailed(error.message))
        })
    }
}
